module.exports = __webpack_public_path__ + "img/ico_chat.63572d56.svg";